import { render, staticRenderFns } from "./ProvincialCompany.vue?vue&type=template&id=47e85cce&scoped=true&"
import script from "./ProvincialCompany.vue?vue&type=script&lang=js&"
export * from "./ProvincialCompany.vue?vue&type=script&lang=js&"
import style0 from "./ProvincialCompany.vue?vue&type=style&index=0&id=47e85cce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e85cce",
  null
  
)

export default component.exports